"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isSubscriptionTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "SubscriptionTransactionDetails";
};
exports.isSubscriptionRecurringBillingScheduleContent = (content) => {
    var _a;
    return ((_a = content) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "SubscriptionRecurringBillingScheduleContent";
};
exports.isSubscriptionPurchaseNotificationDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "SubscriptionPurchaseNotificationDetails";
};
class SubscriptionProvider extends DataProvider_1.default {
    get fragments() {
        return {
            SubscriptionDetails: () => `
        ... on SubscriptionDetails {
          id
          consumerId
          consumer {
            ${this.getFragment("UserPublicData")}
          }
          providerId
          provider {
            ${this.getFragment("UserPublicData")}
          }
          createTime
          levelId
          level {
             ${this.getFragment("SubscriptionLevel")}
          }          
          amount
          expirationTime
          recurringBillingScheduleId
        }
      `,
            TransactionDetails: () => `
        ... on SubscriptionTransactionDetails {
          levelId
          level {
             ${this.getFragment("SubscriptionLevel")}
          }
          providerId
          consumerId
          opponent {
            ${this.getFragment("UserPublicData")}
          }
        }
      `,
            RecurringBillingScheduleContent: () => `
        ... on SubscriptionRecurringBillingScheduleContent {
          subscription {
             ${this.getFragment("SubscriptionDetails")}
          }
        }
      `,
            NotificationDetails: () => `
        ... on SubscriptionPurchaseNotificationDetails {
          amount
          costs {
            ${this.getFragment("CurrencyCost")}
          }
        }
      `,
        };
    }
    search({ data }, fields) {
        return this.query("subscriptionsSearch", { data }, this.getPageableFragment("SubscriptionDetails", fields));
    }
    searchRecurringBillingScheduleByProvider({ data, }) {
        return this.query("subscriptionRecurringScheduleSearch", { data }, this.getPageableFragment("RecurringBillingSchedule"));
    }
    create({ data }) {
        return this.mutate("subscriptionCreate", { data }, this.getFragment("SubscriptionDetails"));
    }
    cancel({ subscriptionId }) {
        return this.mutate("subscriptionCancel", { subscriptionId });
    }
}
exports.SubscriptionProvider = SubscriptionProvider;
//# sourceMappingURL=SubscriptionProvider.js.map